<template>
	<v-layout row wrap style="page-break-inside: avoid">
		<v-flex d-flex xs1>
			<v-card color="grey lighten-1" class="financial-table-header-color">
			</v-card>
		</v-flex>
		<v-flex d-flex xs5>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-2" class="financial-table-header-color">
					<v-card-text class="text-xs-center">
						<div>
							<strong>
								{{index}}
							</strong>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex>
				<v-card color="grey lighten-2" class="financial-table-header-color">
					<v-card-text>
						<b v-if="bold">
							<strong>
								{{label}}
							</strong>
						</b>
						<div v-else>
							<strong>
								{{label}}
							</strong>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card color="grey lighten-3">
				<v-card-text style="text-align: right">
					<span v-if="!documentOnly">
						{{fromProject}} {{isPercentage ? " %" : ""}}
					</span>
					<span v-else>-</span>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card color="grey lighten-3">
				<v-card-text style="text-align: right">
					{{fromDocument}} {{isPercentage ? " %" : ""}}
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: "financial-summary-sub-row",
		props: {
			isPercentage: {
				type: Boolean,
				default: false,
			},
			index: {},
			label: {},
			fromDocument: {},
			fromProject: {},
			bold: {},
			documentOnly: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>
